import { Navigate, Outlet } from 'react-router';
import { useMe } from './useMe';

/** Nested inside RequireAuth, so `data` is already known to be a signed-in user. */
export default function RequireAdmin() {
  const { data } = useMe();
  return data?.admin ? <Outlet /> : <Navigate to="/" replace />;
}
